import { useId } from "react";
export function cx(...values) {
    return values.filter(Boolean).join(" ");
}
export function useStableId(explicitId, prefix) {
    const generated = useId().replace(/[^a-zA-Z0-9_-]/g, "");
    return explicitId ?? `${prefix}-${generated}`;
}
export function joinIds(...ids) {
    const value = ids.filter(Boolean).join(" ");
    return value.length > 0 ? value : undefined;
}
export function toneProperties(tone) {
    const values = {
        neutral: {
            "--obsina-tone": "var(--obsina-text-body)",
            "--obsina-tone-soft": "var(--obsina-surface-sunken)",
            "--obsina-tone-marker": "var(--obsina-text-muted)",
            "--obsina-tone-on-solid": "var(--obsina-white)",
        },
        accent: {
            "--obsina-tone": "var(--obsina-accent-text)",
            "--obsina-tone-soft": "var(--obsina-accent-soft)",
            "--obsina-tone-marker": "var(--obsina-accent)",
            "--obsina-tone-on-solid": "var(--obsina-white)",
        },
        success: {
            "--obsina-tone": "var(--obsina-success)",
            "--obsina-tone-soft": "var(--obsina-success-soft)",
            "--obsina-tone-marker": "var(--obsina-success-marker)",
            "--obsina-tone-on-solid": "var(--obsina-white)",
        },
        warning: {
            "--obsina-tone": "var(--obsina-warning)",
            "--obsina-tone-soft": "var(--obsina-warning-soft)",
            "--obsina-tone-marker": "var(--obsina-warning-marker)",
            "--obsina-tone-on-solid": "var(--obsina-white)",
        },
        danger: {
            "--obsina-tone": "var(--obsina-danger)",
            "--obsina-tone-soft": "var(--obsina-danger-soft)",
            "--obsina-tone-marker": "var(--obsina-danger-marker)",
            "--obsina-tone-on-solid": "var(--obsina-white)",
        },
        info: {
            "--obsina-tone": "var(--obsina-info)",
            "--obsina-tone-soft": "var(--obsina-info-soft)",
            "--obsina-tone-marker": "var(--obsina-info-marker)",
            "--obsina-tone-on-solid": "var(--obsina-white)",
        },
    };
    return values[tone];
}
//# sourceMappingURL=utils.js.map